import { createAction, props } from '@ngrx/store';

export const OpenSidenav = createAction(
  '[Customer Operations: Bulk Operations]: Sidenav Opened'
);

export const CloseSidenav = createAction(
  '[Customer Operations: Bulk Operations]: Sidenav Closed'
);

export const NewBulkOperation = createAction(
  '[Customer Operations: Bulk Operations]: New Bulk Operation',
  props<{ row: any }>()
);

export const EditData = createAction(
  '[Customer Operations: Bulk Operations]: Edit Data'
);
